import { Application } from '@hotwired/stimulus';

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Auto-generated line.
// eslint-disable-next-line import/prefer-default-export
export { application };
